export enum HoldingsCalculationType {
  EOD = 'EOD',
  EOM = 'EOM',
}
